module.exports = __webpack_public_path__ + "static/img/spray--01_2x.d9935ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile/spray--01_2x.png
// module id = k31T
// module chunks = 1